/*
 * @Author: zwcong
 * @Description: 题型
 * @Date: 2021-12-21 16:15:44
 * @LastEditTime: 2022-02-21 16:29:43
 * @FilePath: /teacher-h5/src/service/topic/index-url.js
 */
import http from '../http'
import url from './index-url'
const { get } = http

export default {
  consolidationTopicAnswer(data) {
    return get(url.consolidationTopicAnswer(data.lessonId, data.studentUserId), {
      ...data
    })
  },
  topicAnswer(data) {
    return get(url.topicAnswer, data)
  },
  wrongTopicAnswer(data) {
    return get(url.wrongTopicAnswer(data.lessonId, data.studentUserId), {
      ...data
    })
  },
  historyTopicAnswer(data) {
    return get(url.historyTopicAnswer, data)
  }
}